module.exports = __webpack_public_path__ + "img/location_y.20c462c5.svg";